module.exports = __webpack_public_path__ + "static/img/2_v2.0befe5a8.png";